// @ts-nocheck

import createReducer from '../../../utils/createReducer';
import { PublicGridFilters } from '../types';
import type { PublicGridsState } from '../types';
import { GridsActionTypes } from '../types/actions';
import type { SetPublicGridPageAction, SetPublicGridFilterAction, SetPublicPoolIdAction } from '../types/actions';

export const initialState: PublicGridsState = {
  poolId: null,
  isFetching: false,
  filter: PublicGridFilters.MOST_COMPLETE,
  currentPage: 0,
};

export const setPublicGridPage = (state: PublicGridsState, action: SetPublicGridPageAction): PublicGridsState => {
  const { currentPage: actionCurrentPage } = action.payload;
  const { currentPage: storeCurrentPage } = state;
  if (storeCurrentPage !== actionCurrentPage && actionCurrentPage >= 0) {
    return {
      ...state,
      currentPage: actionCurrentPage,
    };
  }
  return state;
};

export const setPublicGridFilter = (state: PublicGridsState, action: SetPublicGridFilterAction): PublicGridsState => {
  const { filter: actionCurrentFilter } = action.payload;
  const { filter: stateCurrentFilter } = state;
  if (stateCurrentFilter !== actionCurrentFilter) {
    return {
      ...state,
      filter: actionCurrentFilter,
    };
  }
  return state;
};

export const setPublicPoolId = (state: PublicGridsState, action: SetPublicPoolIdAction): PublicGridsState => {
  const { poolId } = action.payload;
  return {
    ...state,
    poolId,
  };
};

export default createReducer(initialState, {
  [GridsActionTypes.SET_PUBLIC_GRID_PAGE]: setPublicGridPage,
  [GridsActionTypes.SET_PUBLIC_GRID_FILTER]: setPublicGridFilter,
  [GridsActionTypes.SET_PUBLIC_POOL_ID]: setPublicPoolId,
});
